<script lang="ts">
  import { track } from "../helpers/mixpanel";

  import Header from "../components/Header.svelte";
  import Stack from "../components/Stack.svelte";

  export let onHeaderClick: (e: Event) => void = (e) => {};

  async function trackSupportClick(e: Event) {
    const target = e.target;

    if (!(target instanceof HTMLAnchorElement)) return;

    const link = target.href;

    if (!link) {
      return;
    }

    e.preventDefault();

    // roughly enough time to at least get the req sent to the backend.
    const timeoutMs = 200;
    let lostRace = false;
    const timeout = new Promise((resolve) => setTimeout(resolve, timeoutMs)).then(() => {
      lostRace = true;
    });
    await Promise.race([
      timeout,
      track("login_more_info_link_cta", { link_name: link }).catch((e) => {
        if (!lostRace) {
          console.error("click tracking failure", e);
        }
      }),
    ]);

    window.location.href = link;
  }
</script>

<div on:click={onHeaderClick}>
  <Header />
</div>
<slot />
<div class="footer">
  <Stack horizontal>
    <div class="footer-pair">
      <a class="link" on:click={trackSupportClick} href="https://rekki.com/chefs">chefs</a>
      <a
        class="link"
        on:click={trackSupportClick}
        href="https://tandc.rekki.com/REKKI%20BUYER%20LICENSE%20AGREEMENT.pdf">terms</a
      >
    </div>
    <div class="footer-pair">
      <a class="link" on:click={trackSupportClick} href="https://rekki.com/suppliers">suppliers</a>
      <a
        class="link"
        on:click={trackSupportClick}
        href="https://tandc.rekki.com/REKKI%20PRIVACY%20POLICY.pdf">privacy</a
      >
    </div>
    <div class="footer-pair">
      <a class="link" on:click={trackSupportClick} href="https://rekki.com/about">about us</a>
      <a class="link" on:click={trackSupportClick} href="https://rekki.com/support">help</a>
    </div>
  </Stack>
</div>

<style>
  .link {
    display: flex;
    flex: 1;
    color: #8c8c8c;
    font-size: 12px;
    line-height: 17px;
    letter-spacing: 0.2px;
    text-decoration: none;
    cursor: pointer;
    margin-right: 15px;
    text-transform: uppercase;
    white-space: nowrap;
    font-family: "REKKI-OCD";
  }

  .footer-pair {
    display: flex;
    flex: 0;
    flex-direction: column;
  }
</style>
